import { mapMutations, mapGetters, mapActions } from "vuex";
import { email, maxLength, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import VueFlatPickr from "vue-flatpickr-component";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";

export default {
    name: "change-contact-form",
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                birthday: "",
                email: "",
                phone: "",
            },
            config: {
                altFormat: "j M, Y",
                dateFormat: "Y-m-d",
                altInput: true,
                locale: Ukrainian,
            },
            isEdit: false,
            showLoader: false,
            validationErrors: {},
        };
    },
    validations() {
        return {
            payload: {
                email: {
                    maxLength: maxLength(30),
                    email,
                },
                phone: {
                    minLength: minLength(19),
                },
            },
        };
    },
    components: {
        "date-picker": VueFlatPickr,
    },
    mounted() {
        if (this.user) {
            this.payload.birthday = this.user.birthday;
            this.payload.email = this.user.email;
            this.payload.phone = this.user.phone;
        }
        this.cachedUser = Object.assign({}, this.payload);
    },
    computed: {
        ...mapGetters({
            isEditProfileData: "profile/editProfileData",
            user: "profile/user",
        }),
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.birthday === "" && this.payload.email === "" && this.payload.phone === "") {
                return true;
            }
            if (
                this.payload.name === this.user.name &&
                this.payload.second_name === this.user.second_name &&
                this.payload.last_name === this.user.last_name
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            updateUserData: `profile/UPDATE_USER_DATA`,
        }),
        ...mapMutations({
            changeEditProfileData: `profile/CHANGE_EDIT_PROFILE_DATA`,
        }),
        cancel() {
            this.payload = Object.assign({}, this.cachedUser);
            this.isEdit = false;
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.showLoader = true;
                let obj = {};
                obj.birthday = this.payload.birthday;
                obj.email = this.payload.email;
                obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                this.updateUserData(obj)
                    .then(() => {
                        this.isEdit = false;
                        this.$toasted.success(this.$t("successChangeData"));
                        this.showLoader = false;
                        this.isEdit = false;
                    })
                    .catch(error => {
                        this.$toasted.error(
                            error.response.data.message ? error.response.data.message : this.$t("failChangeData")
                        );
                    });
            }
        },
    },
};
